<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Delete MySQL user</template>
    <template v-slot:body>
      <p>Are you sure you wish to <strong>permanently</strong> remove the user “{{ user.user }}”?</p>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn :loading="loading" @click="deleteDatabase">Delete</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteUserModal',
  props: {
    user: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
  },
  methods: {
    ...mapActions({
      deleteMysqlUser: 'mysql/deleteMysqlUser',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    async deleteDatabase () {
      this.loading = true
      try {
        await this.deleteMysqlUser({ name: this.user.user, _username: this.$route.query.user })
        this.$emit('action-completed', 'user-deleted')
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
      this.close()
    },
    close () {
      this.$emit('close')
    },
  }
}
</script>
